// extracted by mini-css-extract-plugin
export default {"fullWrap":"Master_fullWrap__kN-Kd","WebPage":"Master_WebPage__00fvC","MasterBottom":"Master_MasterBottom__C8OPT","MasterTop":"Master_MasterTop__EGCPP"};